/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rag_Priority_Locked_By_Internal_Only_NoteInputs */



/**
* | output |
* | --- |
* | "Overridden by \"Only use internal sources\"." |
*
* @param {Rag_Priority_Locked_By_Internal_Only_NoteInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const rag_priority_locked_by_internal_only_note = /** @type {((inputs?: Rag_Priority_Locked_By_Internal_Only_NoteInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rag_Priority_Locked_By_Internal_Only_NoteInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Wird durch \"Nur interne Quellen verwenden\" überschrieben.")
	return /** @type {LocalizedString} */ ("Overridden by \"Only use internal sources\".")
});